"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allKnownCanisterIds = exports.Canisters = void 0;
exports.Canisters = {
    frontend: `${process.env.FRONTEND_CANISTER}`,
    controlCenter: `${process.env.CONTROLCENTER_CANISTER_ID}`,
    management: `${process.env.MANAGEMENT_CANISTER_ID}`,
    analyticsStore: `${process.env.ANALYTICSSTORE_CANISTER_ID}`,
    analyticsStore2: `${process.env.ANALYTICSSTORE2_CANISTER_ID}`,
};
exports.allKnownCanisterIds = [
    exports.Canisters.controlCenter,
    exports.Canisters.management,
    // Canisters.coordinator1,
    // Canisters.coordinator2,
    // Canisters.clientRegistry0,
    // Canisters.clientRegistry512,
    exports.Canisters.analyticsStore,
    exports.Canisters.analyticsStore2,
];
if (!!process.env.IS_TEST_SERVER) {
    console.log("allKnownCanisterIds", exports.allKnownCanisterIds);
}
